module.exports = __webpack_public_path__ + "static/media/building.2882235a.png";